// extracted by mini-css-extract-plugin
export default {"popup":"Feedback__popup___RiOwJ","feedbackWindow":"Feedback__feedbackWindow___XKOZw","field":"Feedback__field___eYVlc","navLink":"Feedback__navLink___NDYPf"};